import React from 'react'
import PropTypes from 'prop-types'
import Accordion from './Accordion'

const mobile = screen.width < 1023

export default function Legend({ active, children = null }) {
    if (children === null) {
        return null
    }

    return (
        <div className={`legend ${active ? 'active' : ''}`}>
            <Accordion
                content={[
                    {
                        id: 'legend',
                        heading: <h4 className="title is-4">Legend</h4>,
                        body: <>{children}</>,
                        initiallyClosed: mobile
                    }
                ]}
            />
        </div>
    )
}

Legend.propTypes = {
    active: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired
}
